import { createFileRoute, redirect } from '@tanstack/react-router'
import { CATEGORIES_TABS } from '~/components/routes/categories/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

// Chaque onglet est une URL distincte ; `/categories` n'a pas de contenu propre et redirige vers le
// premier onglet accessible. La page est donc ouverte dès qu'AU MOINS UN sous-onglet l'est
// (`{ any }`), et `withRoutePermissions` refuse l'accès quand aucun ne l'est.
export const Route = createFileRoute('/_authenticated/categories/')({
  staticData: {
    permission: { any: CATEGORIES_TABS.map((tab) => tab.permission) },
  },
  beforeLoad: ({ context }) => {
    const firstAuthorized = CATEGORIES_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )

    // `withRoutePermissions` a déjà refusé l'accès si aucun onglet n'est accessible : le repli sur
    // le premier onglet ne sert qu'à satisfaire le typage.
    throw redirect({ to: firstAuthorized?.to ?? CATEGORIES_TABS[0].to })
  },
})
withRoutePermissions(Route)
